<template>
    <div v-if="contentRef" class="content-link-ref">
        <router-link
            v-if="contentRef.clientId"
            :to="{ name: 'client-content-links-edit', params: { clientId: contentRef.clientId, contentId: contentRef.contentId } }"
        >{{contentRef.name}}</router-link>
        <router-link
            v-else
            :to="{ name: 'system-content-links-edit', params: { contentId: contentRef.contentId } }"
        >{{contentRef.name}}</router-link>
        ({{contentRef.contentId}})
        <span v-if="contentRef.clientId">, client {{contentRef.clientId}}</span>
        <span class="tag del-btn" title="delete content reference" @click="deleteFunc()">del</span>
    </div>
</template>

<script>
export default {
    name: 'content-link-ref',
    props: {
        contentRef: {
            type: Object,
            required: true
        },
        deleteFunc: {
            type: Function,
            required: true
        }
    }
};
</script>

<style lang="scss">
.content-link-ref {
    padding: 0.28rem;
    a {
        margin-left: 0.2rem;
        margin-right: 0.2rem;
    }

    .del-btn {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/link/content-link-ref.vue